// APP
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {
  WHLayoutConfigDOM,
  WHLayoutNavItemDOM,
  WHRegistredLayoutConfigDOM,
  WHIconENUM,
  WHRouteZeroENUM,
  WHFeatureKeyENUM,
  WHLayoutConfigTypeENUM,
  WHPermissionKeyENUM,
  WHLayoutNavItemTypeENUM,
} from '@workheld/workheld-shared-lib';

// QUICK NAV
export const quickNavDOM: WHLayoutNavItemDOM = {
  enabled: true,
  type: WHLayoutNavItemTypeENUM.QUICKNAV,
  icon: WHIconENUM.WorkheldIcon,
  children: [
    {
      enabled: false,
      type: WHLayoutNavItemTypeENUM.QUICKNAV,
      translateKey: 'app.whsense.label',
      svgIcon: 'workheld-sense-icon',
      routeUrl: environment.whSenseUrl,
    },
    {
      enabled: true,
      type: WHLayoutNavItemTypeENUM.QUICKNAV,
      translateKey: 'app.mgmt.label',
      // icon: WHIconENUM.WorkheldIcon,
      icon: WHIconENUM.SettingsIcon,
      routeUrl: environment.mgmtUrl,
    },
    {
      enabled: true,
      type: WHLayoutNavItemTypeENUM.QUICKNAV,
      translateKey: 'app.help.label',
      icon: WHIconENUM.InfoIcon,
      routeUrl: 'https://tabletsolutions.atlassian.net/wiki/spaces/WD/overview',
    },
  ],
};
// HELP NAV
export const helpNavDOM: WHLayoutNavItemDOM = {
  enabled: true,
  type: WHLayoutNavItemTypeENUM.HELPNAV,
  icon: WHIconENUM.WorkheldIcon,
  children: [
    {
      enabled: true,
      type: WHLayoutNavItemTypeENUM.HELPNAV,
      translateKey: 'nav.help.helpandsupport',
    },
    {
      enabled: true,
      type: WHLayoutNavItemTypeENUM.HELPNAV,
      translateKey: 'nav.help.termsofuse',
    },
    {
      enabled: true,
      type: WHLayoutNavItemTypeENUM.HELPNAV,
      translateKey: 'nav.help.imprint',
    },
    {
      enabled: true,
      type: WHLayoutNavItemTypeENUM.HELPNAV,
      translateKey: `<a>${environment.version}</a>`,
    },
  ],
};

// LAYOUTS
export const registredLayoutConfigDOMList: WHRegistredLayoutConfigDOM[] = [
  {
    enabled: false,
    pictureUrl: '',
    translateKey: 'layout.alpha.label',
    layoutConfigDOM: new WHLayoutConfigDOM().initConfigType(
      WHLayoutConfigTypeENUM.ALPHA,
    ),
  },
  {
    enabled: false,
    pictureUrl: '',
    translateKey: 'layout.beta.label',
    layoutConfigDOM: new WHLayoutConfigDOM().initConfigType(
      WHLayoutConfigTypeENUM.BETA,
    ),
  },
  {
    enabled: false,
    pictureUrl: '',
    translateKey: 'layout.gamma.label',
    layoutConfigDOM: new WHLayoutConfigDOM().initConfigType(
      WHLayoutConfigTypeENUM.GAMMA,
    ),
  },
  {
    enabled: false,
    pictureUrl: '',
    translateKey: 'layout.delta.label',
    layoutConfigDOM: new WHLayoutConfigDOM().initConfigType(
      WHLayoutConfigTypeENUM.DELTA,
    ),
  },
];

// USER ITEMS
export const layoutLoggedInUserNavItemDOMList: WHLayoutNavItemDOM[] = [
  {
    id: 101,
    enabled: false,
    translateKey: 'nav.userprofile.root',
    featureKey: WHFeatureKeyENUM.PROFILE,
    type: WHLayoutNavItemTypeENUM.NAVIGATE,
    routeUrl: WHRouteZeroENUM.PROFILE,
    icon: WHIconENUM.UserIcon,
  },
  {
    id: 106,
    enabled: true,
    translateKey: 'nav.userprofile.logout',
    type: WHLayoutNavItemTypeENUM.LOGOUT,
    icon: WHIconENUM.LogoutIcon,
  },
];

// NAVIGATION
export const layoutNavItemDOMList: WHLayoutNavItemDOM[] = [
  // Overview
  {
    id: 1,
    featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW,
    enabled: false,
    translateKey: 'nav.overview.root',
    type: WHLayoutNavItemTypeENUM.NAVIGATE,
    icon: WHIconENUM.PerformanceDashboardIcon,
    children: [
      {
        id: 101,
        parentId: 1,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW,
        enabled: false,
        translateKey: 'nav.overview.statusdashboard',
        routeUrl: WHRouteZeroENUM.STATUS_OVERVIEW,
        icon: WHIconENUM.StatusOverviewIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 102,
        parentId: 1,
        featureKey: WHFeatureKeyENUM.DAILY_DASHBOARD,
        enabled: false,
        translateKey: 'nav.overview.dailydashboard',
        routeUrl: WHRouteZeroENUM.DAILY_DASHBOARD,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_COORDINATOR_DAILY_READ,
        },
        matIcon: 'space_dashboard',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 103,
        parentId: 1,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW_PROJECT_OVERVIEW,
        overruleEnabled: true,
        enabled: false,
        translateKey: 'nav.overview.projectoverview',
        routeUrl: WHRouteZeroENUM.PROJECT_OVERVIEW,
        icon: WHIconENUM.ProjectIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 104,
        parentId: 1,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW_REPORTS_OVERVIEW,
        enabled: true,
        translateKey: 'nav.overview.reportsoverview',
        routeUrl: WHRouteZeroENUM.WORK_OBJECT_REPORTS_OVERVIEW,
        icon: WHIconENUM.ReportIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_REPORT_READ,
        },
      },
    ],
  },

  // Work
  {
    id: 2,
    featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW,
    enabled: false,
    translateKey: 'nav.work.root',
    icon: WHIconENUM.WorkStepIcon,
    type: WHLayoutNavItemTypeENUM.NAVIGATE,
    permissionCheckConfig: {
      permission: [
        WHPermissionKeyENUM.FLOW_TECHNICIAN_PROJECT_READ,
        WHPermissionKeyENUM.FLOW_TECHNICIAN_CASE_READ,
        WHPermissionKeyENUM.FLOW_TECHNICIAN_STANDING_ORDER_READ,
        WHPermissionKeyENUM.FLOW_MAINTENANCE_NOTIFICATION_READ,
        WHPermissionKeyENUM.FLOW_MAINTENANCE_NOTIFICATION_READ_OWN,
        WHPermissionKeyENUM.FLOW_COORDINATOR_TEAM_PLANNER_READ,
      ],
      operator: 'OR',
    },
    children: [
      {
        id: 201,
        parentId: 2,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW_QUICK_PROJECT,
        enabled: false,
        translateKey: 'nav.work.quickcreateproject',
        icon: WHIconENUM.ProjectIcon,
        type: WHLayoutNavItemTypeENUM.MODAL,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_TECHNICIAN_PROJECT_CREATE,
        },
      },
      {
        id: 202,
        parentId: 2,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW_PROJECT,
        enabled: false,
        translateKey: 'nav.work.project',
        routeUrl: WHRouteZeroENUM.PROJECTS,
        icon: WHIconENUM.ProjectIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_TECHNICIAN_PROJECT_READ,
        },
      },
      {
        id: 203,
        parentId: 2,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW_CASE,
        enabled: false,
        translateKey: 'nav.work.case',
        routeUrl: WHRouteZeroENUM.CASES,
        icon: WHIconENUM.CaseIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_TECHNICIAN_CASE_READ,
        },
      },
      {
        id: 204,
        parentId: 2,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW_STANDING_ORDER,
        enabled: false,
        translateKey: 'nav.work.standingorder',
        routeUrl: WHRouteZeroENUM.STANDING_ORDER,
        icon: WHIconENUM.StandingOrdersIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_TECHNICIAN_STANDING_ORDER_READ,
        },
      },
      {
        id: 205,
        parentId: 2,
        featureKey: WHFeatureKeyENUM.MAINTENANCE_NOTIFICATIONS,
        enabled: false,
        translateKey: 'ui.maintenancenotifications.label',
        routeUrl: WHRouteZeroENUM.MAINTENANCE_NOTIFICATIONS,
        icon: WHIconENUM.DefectIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: [
            WHPermissionKeyENUM.FLOW_MAINTENANCE_NOTIFICATION_READ,
            WHPermissionKeyENUM.FLOW_MAINTENANCE_NOTIFICATION_READ_OWN,
          ],
          operator: 'OR',
        },
      },
      {
        id: 206,
        parentId: 2,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW_UNASSIGNED_ITEMS,
        enabled: false,
        translateKey: 'nav.overview.unassignedentries',
        routeUrl: WHRouteZeroENUM.ENTRIES_UNASSIGNED,
        icon: WHIconENUM.UnassignedEntriesIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: [
            WHPermissionKeyENUM.FLOW_TECHNICIAN_ENTRY_READ,
            WHPermissionKeyENUM.FLOW_REPORT_READ,
          ],
          operator: 'OR',
        },
      },
      {
        id: 207,
        parentId: 2,
        featureKey: WHFeatureKeyENUM.EXPERIMENTAL_CASE_QUICK_CREATE,
        enabled: false,
        translateKey: 'nav.work.casecreationwidget',
        routeUrl: WHRouteZeroENUM.CASES_CATEGORY,
        icon: WHIconENUM.CaseIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_TECHNICIAN_CASE_READ,
        },
      },
      {
        id: 208,
        parentId: 2,
        featureKey: WHFeatureKeyENUM.ADVANCED_TEAM_PLANNER,
        enabled: false,
        translateKey: 'nav.overview.teamplanner',
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_COORDINATOR_TEAM_PLANNER_READ,
        },
        routeUrl: WHRouteZeroENUM.TEAM_PLANNER,
        icon: WHIconENUM.PlanningBoardIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
    ],
  },

  // Shifts
  {
    id: 3,
    featureKey: WHFeatureKeyENUM.SHIFT_MANAGEMENT,
    enabled: false,
    translateKey: 'shift.label.shiftModels',
    matIcon: 'free_cancellation',
    type: WHLayoutNavItemTypeENUM.NAVIGATE,
    permissionCheckConfig: {
      permission: [
        WHPermissionKeyENUM.FLOW_WORK_TIME_READ,
        WHPermissionKeyENUM.FLOW_TEAM_SHIFT_READ,
        WHPermissionKeyENUM.FLOW_SHIFT_CALENDAR_DEFINITION_READ,
      ],
      operator: 'OR',
    },
    children: [
      {
        id: 301,
        parentId: 3,
        featureKey: WHFeatureKeyENUM.SHIFT_PLANNER,
        enabled: false,
        translateKey: 'nav.overview.shiftplanner',
        routeUrl: WHRouteZeroENUM.SHIFT_PLANNER,
        matIcon: 'view_timeline',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 302,
        parentId: 3,
        featureKey: WHFeatureKeyENUM.INFOSCREEN,
        enabled: false,
        translateKey: 'nav.overview.infoscreen',
        routeUrl: WHRouteZeroENUM.INFOSCREEN,
        matIcon: 'track_changes',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 303,
        parentId: 3,
        featureKey: WHFeatureKeyENUM.SHIFT_MANAGEMENT,
        enabled: false,
        translateKey: 'nav.shiftgroup.root',
        routeUrl: WHRouteZeroENUM.SHIFT_GROUPS,
        matIcon: 'schedule',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_WORK_TIME_READ,
        },
      },
      {
        id: 304,
        parentId: 3,
        featureKey: WHFeatureKeyENUM.SHIFT_MANAGEMENT,
        enabled: false,
        translateKey: 'nav.shiftdefinition.root',
        routeUrl: WHRouteZeroENUM.SHIFT_DEFINITIONS,
        matIcon: 'manage_history',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_TEAM_SHIFT_READ,
        },
      },
      {
        id: 305,
        parentId: 3,
        featureKey: WHFeatureKeyENUM.SHIFT_MANAGEMENT,
        enabled: false,
        translateKey: 'nav.shiftcalendar.root',
        routeUrl: WHRouteZeroENUM.SHIFT_CALENDAR,
        matIcon: 'event',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_SHIFT_CALENDAR_DEFINITION_READ,
        },
      },
      {
        id: 306,
        parentId: 3,
        featureKey: WHFeatureKeyENUM.SHIFT_BOOK,
        enabled: false,
        translateKey: 'nav.overview.shiftbook',
        routeUrl: WHRouteZeroENUM.SHIFT_BOOK,
        matIcon: 'auto_stories',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_SHIFT_BOOK_READ,
        },
      },
    ],
  },

  // Equipment
  {
    id: 4,
    featureKey: WHFeatureKeyENUM.INSTALLED_BASE,
    enabled: false,
    translateKey: 'nav.equipment.root',
    icon: WHIconENUM.EquipmentIcon,
    type: WHLayoutNavItemTypeENUM.NAVIGATE,
    permissionCheckConfig: {
      permission: WHPermissionKeyENUM.FLOW_EQUIPMENT_READ,
    },
    children: [
      {
        id: 401,
        parentId: 4,
        featureKey: WHFeatureKeyENUM.EQUIPMENT_PLANNER,
        enabled: false,
        translateKey: 'nav.equipment.planner',
        routeUrl: WHRouteZeroENUM.EQUIPMENT_PLANNER,
        matIcon: 'view_in_ar',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 402,
        parentId: 4,
        featureKey: WHFeatureKeyENUM.INSTALLED_BASE,
        enabled: false,
        translateKey: 'nav.equipment.management',
        routeUrl: WHRouteZeroENUM.EQUIPMENTS,
        icon: WHIconENUM.EquipmentIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_EQUIPMENT_READ,
        },
      },
      {
        id: 403,
        parentId: 4,
        featureKey: WHFeatureKeyENUM.FIX_MAINTENANCE_PLAN,
        enabled: false,
        translateKey: 'nav.equipment.maintenanceplan',
        routeUrl: WHRouteZeroENUM.MAINTENANCE_PLAN_FIX,
        icon: WHIconENUM.MaintenancePlanIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 404,
        parentId: 4,
        featureKey: WHFeatureKeyENUM.MAINTENANCE_PLAN,
        enabled: false,
        translateKey: 'nav.equipment.maintenanceplan',
        routeUrl: WHRouteZeroENUM.MAINTENANCE_PLAN,
        icon: WHIconENUM.MaintenancePlanIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
    ],
  },

  // Material
  {
    id: 5,
    featureKey: WHFeatureKeyENUM.MATERIAL,
    enabled: false,
    translateKey: 'nav.material.root',
    icon: WHIconENUM.MaterialConsumptionIcon,
    type: WHLayoutNavItemTypeENUM.NAVIGATE,
    permissionCheckConfig: {
      permission: WHPermissionKeyENUM.FLOW_MATERIAL_READ,
    },
    children: [
      {
        id: 501,
        parentId: 5,
        featureKey: WHFeatureKeyENUM.MATERIAL,
        enabled: false,
        translateKey: 'nav.material.management',
        routeUrl: WHRouteZeroENUM.MATERIALS,
        icon: WHIconENUM.MaterialConsumptionIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_MATERIAL_READ,
        },
      },
      {
        id: 502,
        parentId: 5,
        featureKey: WHFeatureKeyENUM.MATERIAL_INVENTORY,
        enabled: false,
        translateKey: 'nav.humanresource.carstock',
        routeUrl: WHRouteZeroENUM.MATERIALINVENTORY,
        icon: WHIconENUM.InventoryIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
    ],
  },

  // Master Data
  {
    id: 6,
    featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW,
    enabled: false,
    translateKey: 'nav.masterdata.root',
    icon: WHIconENUM.ServerIcon,
    type: WHLayoutNavItemTypeENUM.NAVIGATE,
    permissionCheckConfig: {
      permission: [
        WHPermissionKeyENUM.FLOW_COORDINATOR_CUSTOMER_READ,
        WHPermissionKeyENUM.FLOW_TECHNICIAN_CHECKLIST_TEMPLATE_READ,
        WHPermissionKeyENUM.FLOW_COORDINATOR_PROJECT_TEMPLATE_READ,
        'flow.coordinator.execution_group.read',
        WHPermissionKeyENUM.FLOW_COORDINATOR_TOOL_READ,
        WHPermissionKeyENUM.MANAGEMENT_USER_READ,
      ],
      operator: 'OR',
    },
    children: [
      {
        id: 601,
        parentId: 6,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW,
        enabled: false,
        translateKey: 'nav.masterdata.customer',
        routeUrl: WHRouteZeroENUM.CUSTOMERS,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_COORDINATOR_CUSTOMER_READ,
        },
        icon: WHIconENUM.CustomerIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 602,
        parentId: 6,
        featureKey: WHFeatureKeyENUM.CORE_WORK_FLOW,
        enabled: false,
        translateKey: 'nav.masterdata.checklistdefinition',
        routeUrl: WHRouteZeroENUM.CHECKLIST_DEFINITION,
        icon: WHIconENUM.ChecklistDefinitionIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission:
            WHPermissionKeyENUM.FLOW_TECHNICIAN_CHECKLIST_TEMPLATE_READ,
        },
      },
      {
        id: 603,
        parentId: 6,
        featureKey: WHFeatureKeyENUM.TEMPLATE,
        enabled: false,
        translateKey: 'nav.masterdata.template',
        routeUrl: WHRouteZeroENUM.WORK_OBJECT_TEMPLATES,
        icon: WHIconENUM.ProjectTemplateIcon,
        permissionCheckConfig: {
          permission:
            WHPermissionKeyENUM.FLOW_COORDINATOR_PROJECT_TEMPLATE_READ,
        },
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 604,
        parentId: 6,
        featureKey: WHFeatureKeyENUM.EXECUTION_GROUPS,
        enabled: false,
        translateKey: 'nav.masterdata.executiongroups',
        routeUrl: WHRouteZeroENUM.EXECUTION_GROUPS,
        matIcon: 'category',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: 'flow.coordinator.execution_group.read',
        },
      },
      {
        id: 605,
        parentId: 6,
        featureKey: WHFeatureKeyENUM.TOOL,
        enabled: false,
        translateKey: 'nav.masterdata.tool',
        routeUrl: WHRouteZeroENUM.TOOLS,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_COORDINATOR_TOOL_READ,
        },
        icon: WHIconENUM.ToolsIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 606,
        parentId: 6,
        featureKey: WHFeatureKeyENUM.TECHNICIAN_MANAGEMENT,
        permissionKey: WHPermissionKeyENUM.MANAGEMENT_USER_READ,
        enabled: false,
        translateKey: 'nav.masterdata.technicianonboarding',
        routeUrl: WHRouteZeroENUM.WORKERS,
        icon: WHIconENUM.UsersIcon,
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
    ],
  },

  // Human Resources
  {
    id: 7,
    featureKey: WHFeatureKeyENUM.HUMAN_RESOURCES,
    enabled: false,
    translateKey: 'nav.humanresources.root',
    matIcon: 'groups',
    type: WHLayoutNavItemTypeENUM.NAVIGATE,
    permissionCheckConfig: {
      permission: [
        WHPermissionKeyENUM.FLOW_HR_WORKER_READ,
        WHPermissionKeyENUM.FLOW_ABSENCE_REQUEST_READ,
        WHPermissionKeyENUM.FLOW_JOB_PROFILE_READ,
        WHPermissionKeyENUM.FLOW_QUALIFICATION_READ,
        WHPermissionKeyENUM.FLOW_SKILL_READ,
      ],
      operator: 'OR',
    },
    children: [
      {
        id: 701,
        parentId: 7,
        featureKey: WHFeatureKeyENUM.HUMAN_RESOURCES,
        enabled: false,
        translateKey: 'nav.hrworker.root',
        routeUrl: WHRouteZeroENUM.HR_WORKERS,
        matIcon: 'groups',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_HR_WORKER_READ,
        },
      },
      {
        id: 702,
        parentId: 7,
        featureKey: WHFeatureKeyENUM.ABSENCE_REQUESTS,
        enabled: false,
        translateKey: 'nav.absencerequest.root',
        routeUrl: WHRouteZeroENUM.ABSENCE_REQUESTS,
        matIcon: 'event_busy',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_ABSENCE_REQUEST_READ,
        },
      },
      {
        id: 703,
        parentId: 7,
        featureKey: WHFeatureKeyENUM.SKILL_MANAGEMENT,
        enabled: false,
        translateKey: 'nav.jobrequirements.root',
        routeUrl: WHRouteZeroENUM.JOB_REQUIREMENTS,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_JOB_PROFILE_READ,
        },
        matIcon: 'business_center',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 704,
        parentId: 7,
        featureKey: WHFeatureKeyENUM.SKILL_MANAGEMENT,
        enabled: false,
        translateKey: 'nav.qualifications.root',
        routeUrl: WHRouteZeroENUM.QUALIFICATIONS,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_QUALIFICATION_READ,
        },
        matIcon: 'workspace_premium',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
      {
        id: 705,
        parentId: 7,
        featureKey: WHFeatureKeyENUM.SKILL_MANAGEMENT,
        enabled: false,
        translateKey: 'nav.skills.root',
        routeUrl: WHRouteZeroENUM.SKILLS,
        permissionCheckConfig: {
          permission: WHPermissionKeyENUM.FLOW_SKILL_READ,
        },
        matIcon: 'bolt',
        type: WHLayoutNavItemTypeENUM.NAVIGATE,
      },
    ],
  },
];

export function localeFactory(translate: TranslateService): string {
  // Here you can add more logic if needed to determine the locale
  return translate.currentLang || 'de-AT'; // Default to 'en-US' if no currentLang is set
}
